import type { Identity } from "@cosmosai/shared";
import type { AuthPort } from "./auth-port";

/** The same identity as the web API's local mode and the cosmos API's local caller. */
export const LOCAL_IDENTITY: Identity = {
  sub: "local",
  name: "Local developer",
  organizations: ["default"],
  // As the web API's local developer: the admin pages render and answer 503 without Keycloak.
  accountType: "tenant-admin",
};

/** No identity provider (development only): always signed in, no token sent. */
export class LocalAuth implements AuthPort {
  async current(): Promise<Identity> {
    return LOCAL_IDENTITY;
  }

  async accessToken(): Promise<undefined> {
    return undefined;
  }

  async signIn(returnTo: string): Promise<void> {
    window.location.assign(returnTo);
  }

  async completeSignIn(): Promise<string> {
    return "/";
  }

  async signOut(): Promise<void> {
    window.location.assign("/signed-out");
  }
}
